// processing_rules strategy (parquet_raw → parquet_processed).
// Its PRIVATE config IS the data-dictionary / processing-rules surface: the
// rules, mappings, and element→target bindings the pyarrow engine reads. We
// reuse the existing pages rather than duplicating them.
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { registerStrategyKind } from "../registry";

function ProcessingRulesPanel() {
  const links = [
    { title: "Overview", url: createPageUrl("data-dictionary") },
    { title: "Elements", url: createPageUrl("data-elements") },
    { title: "Source Mappings", url: createPageUrl("source-mappings") },
    { title: "Reference Lists", url: createPageUrl("reference-lists") },
    { title: "Processing Rules", url: createPageUrl("processing-rules") },
    { title: "Data Review", url: createPageUrl("data-review") },
    { title: "Quality", url: createPageUrl("dictionary-quality") },
  ];
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold mb-1">Processing Rules transformation</h2>
      <p className="text-sm text-gray-500 mb-4">
        parquet_raw → parquet_processed. Applies the recipe's processing rules to
        records columnar. Its configuration is the data dictionary:
      </p>
      <div className="grid grid-cols-2 gap-3 max-w-2xl">
        {links.map((l) => (
          <Link key={l.url} to={l.url}
            className="block rounded-lg border border-gray-200 px-4 py-3 hover:border-blue-400 hover:bg-blue-50 no-underline text-gray-800">
            {l.title}
          </Link>
        ))}
      </div>
    </div>
  );
}

registerStrategyKind("processing_rules", { label: "Processing Rules", Panel: ProcessingRulesPanel });
